import CheckboxComponent from '@components/common/CheckBox';
import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from '../../components/common/Button';
import './RoleManagementUpdateModal.css'

interface showModalProps {
    showModal: boolean;
    handleClose: () => void;
    handleChange: (changedData: any, checkBoxName:string) => void;
    modalData: {modifyAllUserType: boolean};
    handleSubmit: () => void;
    roleName: string;
};


const RoleManagementUpdateModal = (props: showModalProps) => {
  const { showModal, handleClose, handleChange, modalData, handleSubmit, roleName } = props;

  return (
    <div className="modal_role_update">
      <Modal
        show={showModal}
        onHide={()=>{}}
        dialogClassName={'role-update-card-modal'}
        centered={true}
      >
        <Modal.Body>
          <div className="role-container">
            <div className="role-modal-header">
              <span className='role-modal-header-title'>Privilege Changes</span>

              <Button
                onClick={handleClose}
                disabled={false}
                id="cancel"
                buttonName={'Cancel'}
                colorType={'save'}
                icon={''}
                iconPosition={'right'}
              />
            </div>
            <div className="role-checkbox-container">
              <CheckboxComponent
                className={''}
                placeCheckboxBefore={false}
                isChecked={modalData.modifyAllUserType}
                checkBoxName={
                  'Apply these modified privileges into all different designations with same User Type.'
                }
                disabled={false}
                onCheckboxChange={(changedData) =>
                  handleChange(changedData, 'modifyAllUserType')
                }
              />
            </div>

            <div className="confirm-button">
              <Button
                onClick={handleSubmit}
                disabled={false}
                id={''}
                buttonName={'Confirm'}
                colorType={'primary'}
                icon={''}
                iconPosition={'right'}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default RoleManagementUpdateModal;